let libraryPromise
let stylesPromise
let retries = 0

// pdf.js's own viewer styles (text, annotation and page layers). Only a PDF
// viewer needs them, so they load with the runtime instead of blocking the
// first paint of every page.
const PDF_VIEWER_STYLESHEET = "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.7.76/web/pdf_viewer.css"

export function loadPdfLibrary() {
  if (!libraryPromise) {
    // Propshaft resolves this to a fingerprinted asset in both deployment modes.
    const assetUrl = RAILS_ASSET_URL("/pdf_runtime.js")
    const url = retries ? `${assetUrl}${assetUrl.includes('?') ? '&' : '?'}retry=${retries}` : assetUrl
    libraryPromise = Promise.all([import(url), loadPdfStyles()]).then(([library]) => library).catch(error => {
      libraryPromise = null
      retries += 1
      throw error
    })
  }
  return libraryPromise
}

// Resolves once the stylesheet applies, so no text layer paints unstyled over
// its page. A failed load still resolves, as the old <head> link did; a retried
// runtime load asks for it again. Appended last in <head>, it keeps the cascade it had
// there: after application.css, so it still wins ties against pdfjs.css.
function loadPdfStyles() {
  if (!stylesPromise) {
    stylesPromise = new Promise(resolve => {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = PDF_VIEWER_STYLESHEET
      link.addEventListener("load", () => resolve())
      link.addEventListener("error", () => {
        link.remove()
        stylesPromise = null
        resolve()
      })
      document.head.append(link)
    })
  }
  return stylesPromise
}
